<!--
 * @Author: your name
 * @Date: 2021-03-15 21:18:13
 * @LastEditTime: 2021-08-05 17:30:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\App.vue
-->

<template>
  <div id="app">
    <!-- 一级路由入口 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "APP",
};
</script>
<style lang="less">
.vjs-custom-skin > .video-js:hover{
  background-color: rgba(0, 0, 0, 0.45);
}
</style>
